import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { PusherService } from '../_service/pusher.service';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NotificationService } from '../_service/notification.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    NgbModule,
    RouterModule,
    FormsModule,
    CommonModule,
    NgSelectModule
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  minutes = 0
  private modalService = inject(NgbModal);
  buzzNotification: any = null;
  user: any;
  notificationCount: number = 0;

  constructor(
    private pusherService: PusherService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    var user = JSON.parse(localStorage.getItem('user') || '{}');
    var tenant = user.user.tenant;
    var mes = `waiter-notification-${tenant}-all`;
    this.user = user;
    // this.pusherService.channel.bind(mes, (data: any) => {
    //   if (data.type == "buzz") {
    //     this.playBeep();
    //     var message = `${data.table} needs your attention`
    //     this.buzzNotification = message;
    //   } else if (data.type == "new_order") {
    //     this.playBeep();
    //     var message = `There's a new order`
    //     this.buzzNotification = message;
    //   } else if (data.type == "chat") {
    //     if (data.waiter_id == user.user.pusher_id) {
    //       var message = `Message from ${data.name}`
    //       this.buzzNotification = message;
    //     }

    //   }
    // })

    // Subscribe to notification count changes
    this.notificationService.notificationCount$.subscribe(count => {
      this.notificationCount = count;
    });
  }

  playBeep() {
    const audio = new Audio('beep.mp3'); // Replace with the correct path to your audio file
    audio.load(); // Load the audio file before playing it
    audio.play().catch(error => {
      console.error("Error playing audio", error); // Catch errors if any
    });
  }


  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'md' }).result
  }
  settime(content2: any) {
    this.modalService.dismissAll()
    this.modalService.open(content2, { centered: true, size: 'md' }).result
  }
  minus() {
    if (this.minutes >= 1) {
      this.minutes--
    }
  }
  plus() {
    this.minutes++
  }

  setMinutes(value: number) {
    this.minutes = value;
  }

  update() {
    // Add logic to update wait time
    this.modalService.dismissAll();
  }
}
